enum DonorShieldDirectAction {
    Edit = 1,
    Delete = 2,
    ApplyforWage = 3,
    EditWageAndTravel = 4,
    OrderStreamlinedSerology = 5
}

export default DonorShieldDirectAction;